import React, { useEffect, useState } from 'react'
import { useTranslation } from 'i18n'
import {
  ButtonDownload,
  ContentButton,
  Text
} from 'components/modular/button-actions/button-download-offline/ButtonDownloadOffline.styles'

const ButtonDownloadArticle = ({
  articleId,
  seedPrPocEnabled,
  dueAt = null,
  noBorder = false,
  hasText = false
}: {
  articleId: number
  seedPrPocEnabled: boolean
  dueAt?: string | null
  noBorder?: boolean
  hasText?: boolean
}) => {
  const { t } = useTranslation()
  const [isSupported, setIsSupported] = useState(
    () => window.nativeFeatures?.offlineArticles === true
  )

  useEffect(() => {
    const updateSupport = (): void => {
      setIsSupported(window.nativeFeatures?.offlineArticles === true)
    }

    window.addEventListener('native-features-ready', updateSupport)
    updateSupport()
    return () => {
      window.removeEventListener('native-features-ready', updateSupport)
    }
  }, [])

  if (!seedPrPocEnabled || !isSupported || !window.ReactNativeWebView)
    return null

  const handleClick = (event: React.MouseEvent): void => {
    event.stopPropagation()
    event.preventDefault()
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'download_article',
        data: { id: articleId, dueAt }
      })
    )
  }

  return (
    <ContentButton hasText={hasText} onClick={handleClick}>
      <ButtonDownload
        iconName="download"
        theme={{ type: 'secondary', size: noBorder ? 'large' : 'xLarge' }}
        noBorder={noBorder}
        aria-label={t('Baixar notícia')}
      />
      {hasText && <Text>{t('Baixar notícia')}</Text>}
    </ContentButton>
  )
}

export default ButtonDownloadArticle
